<template>
  <div>
    <b-modal
      id="confirm-inactive-user"
      title="ATENÇÃO"
      no-close-on-backdrop
      hide-footer
    >
      <div class="row">
        <div class="col-md-12">
          <span>
            ATENÇÃO AO INATIVAR O CLIENTE O CONTRATO NÃO SERÁ ENCERRADO,
            permanecendo, portanto, AS COBRANÇAS. Caso queira encerrar, acesse a
            aba correspondente.
            <br />
            <br />
            VOCÊ NÃO TERÁ MAIS ACESSO ao cliente inativo.
            <br />
            Antes de inativar, verifique TODAS AS PENDÊNCIAS COMO: SEMIOLOGIA,
            PRESCRIÇÃO (data inicial e final) E ANOTAÇÃO DE CUIDADOS.
            <br />
            <br />
            É possível gerar relatórios dos clientes inativos ao filtrar essa
            opção.
          </span>
        </div>
        <div
          class="col-md-12 d-flex align-items-center justify-content-between"
        >
          <v-btn
            :disabled="loadingUpdate"
            class="btn-cancel"
            @click="$bvModal.hide('confirm-inactive-user')"
          >
            CANCELAR
          </v-btn>
          <v-btn
            :disabled="loadingUpdate"
            class="btn-save"
            @click="update(true)"
          >
            <i class="fas fa-save mr-2 text-twenty" />
            {{ loadingUpdate ? "Carregando" : "SALVAR MESMO ASSIM" }}
          </v-btn>
        </div>
      </div>
    </b-modal>
    <new-bed @created="getAllBedsWithNoBond" />
    <new-type-of-hosting @created="getTypeOfHostings" />
    <b-overlay :show="loadingResident" opacity="0.99">
      <div class="row">
        <div
          v-if="stepInformation == 'BASICO'"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <h6 class="check-text-center">Pessoal</h6>
          <hr />
          <p class="mb-0 check-text-center">PATOLOGIA</p>
          <p class="worksansr check-text-center">
            {{ resident.pathology ? resident.pathology : "NÃO INFORMADO" }}
          </p>
          <hr />
          <p class="mb-0 check-text-center">ALERGIAS DIVERSAS</p>
          <p class="worksansr check-text-center">
            {{
              resident.miscellaneous_allergies
                ? resident.miscellaneous_allergies
                : "NÃO INFORMADO"
            }}
          </p>
          <hr />
          <p class="mb-0 check-text-center">TIPO DE ALIMENTAÇÃO</p>
          <p class="worksansr check-text-center">
            {{
              resident.type_of_food ? resident.type_of_food : "NÃO INFORMADO"
            }}
          </p>
          <hr />
          <p class="mb-0 check-text-center">IDADE / DATA DE NASCIMENTO</p>
          <p class="worksansr check-text-center">
            {{ getAge(resident.date_of_birth) }} anos -
            {{ formatDate(resident.date_of_birth, false) }}
          </p>
          <hr />
          <p class="mb-0 check-text-center">GÊNERO</p>
          <p class="worksansr check-text-center upper-text">
            {{ resident.gender_name }}
          </p>
          <hr />
          <p class="mb-0 check-text-center">DATA DA HOSPEDAGEM</p>
          <p class="worksansr check-text-center">
            {{ formatDate(resident.date_of_reception, false) }}
          </p>
          <hr />
          <p class="mb-0 check-text-center">LEITO</p>
          <p v-if="bed" class="worksansr check-text-center">
            <span v-if="bed">
              Nº {{ bed.number }} - Andar {{ bed.walk }} - Quarto
              {{ bed.bedroom }} - (ALA/Setor) {{ bed.ward_or_sector }}
            </span>
            <span v-if="!bed"> NÃO INFORMADO! </span>
          </p>
          <hr />
          <p class="mb-0 check-text-center">GRAU DE DEPENDÊNCIA</p>
          <p class="worksansr check-text-center">
            {{ degree_of_dependence_name || "NÃO INFORMADO" }}
          </p>
          <hr />
          <div>
            <p class="mb-0 check-text-center">DOCUMENTOS</p>
            <Document
              :rest_home_id="rest_home_id"
              :resident_id="resident_id"
              :user_id="user_id"
              :actions="false"
            />
            <hr />
          </div>
          <p class="mb-0 check-text-center">FAMILIARES</p>
          <div v-if="customerHasResident.length == 0">
            Sem familiar(es) vinculados!
          </div>
          <div v-if="customerHasResident.length > 0">
            <div
              class="worksansr check-text-center m-0 border-bottom mb-5"
              v-for="(customer, key) in customerHasResident"
              :key="key"
            >
              <h6 class="upper-text text-fourteen">
                NOME: {{ customer.customer_name }}
              </h6>
              Responsável pelo pagamento?
              <span
                class="badge badge-success"
                v-if="customer.responsible_for_payment == 1"
                >SIM</span
              >
              <span
                class="badge badge-danger"
                v-if="customer.responsible_for_payment != 1"
                >NÃO</span
              >
              <br />
              Sacador avalista?
              <span
                class="badge badge-success"
                v-if="customer.guarantor == 'SIM'"
                >SIM</span
              >
              <span
                class="badge badge-danger"
                v-if="customer.guarantor != 'SIM'"
                >NÃO</span
              >
              <br />
              <span v-if="customer.first_phone">
                1º telefone: {{ customer.first_phone }}
              </span>
              <span v-if="customer.second_phone">
                2º telefone: {{ customer.second_phone }}
              </span>
            </div>
          </div>
          <hr />
          <v-btn class="btn-edit" @click="handleInformationStep('GERAL')">
            <i class="fas fa-pencil-alt mr-2 text-twenty"></i>
            EDITAR</v-btn
          >
          <v-btn
            v-if="permission('read', 'resident')"
            type="button"
            @click="handlePrint"
            class="btn-print float-right"
          >
            <i class="fas fa-print mr-2 text-twenty"></i>
            IMPRIMIR
          </v-btn>

          <!-- <v-tabs v-model="tab" background-color="transparent" show-arrows>
              <v-tab v-for="item in items" :key="item.tab">
                {{ item.tab }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="item in items" :key="item.tab">
                <div class="col-xl-12">
                  {{ item.content }}
                </div>
              </v-tab-item>
            </v-tabs-items> -->
        </div>

        <div v-if="stepInformation == 'GERAL'" class="col-md-12 p-0">
          <div class="row m-0">
            <div class="col-xl-6 col-lg-7 col-md-7 col-sm-7 col-6 pb-0">
              <button
                class="btn-return-default mb-5"
                @click="handleInformation"
              >
                <i class="fas fa-arrow-left mr-2 text-twenty"></i>
                VOLTAR
              </button>
            </div>
            <div
              class="col-xl-3 col-lg-5 col-md-5 col-sm-5 col-6 text-right pb-0"
            >
              <WarningRequiredFields v-if="permission('edit', 'resident')" />
            </div>
          </div>
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <a
                v-if="permission('read', 'resident')"
                @click="handleStep('INFORMACOES')"
                :class="[
                  'nav-link link-nav-resident',
                  step == 'INFORMACOES' && 'active',
                ]"
                id="nav-informacoes"
                data-toggle="tab"
                href="#informacoes"
                role="tab"
                aria-controls="informacoes"
                aria-selected="true"
                >GERAL</a
              >
              <a
                v-if="permission('read', 'resident_address')"
                @click="handleStep('INFORMACOES_ENDERECO')"
                :class="[
                  'nav-link link-nav-resident',
                  step == 'INFORMACOES_ENDERECO' && 'active',
                ]"
                id="nav-informacoes-endereco"
                data-toggle="tab"
                href="#informacoes-endereco"
                role="tab"
                aria-controls="informacoes-endereco"
                aria-selected="false"
                >ENDEREÇO</a
              >
              <a
                v-if="permission('read', 'resident_documents')"
                @click="handleStep('INFORMACOES_DOCUMENTOS')"
                :class="[
                  'nav-link link-nav-resident',
                  step == 'INFORMACOES_DOCUMENTOS' && 'active',
                ]"
                id="nav-informacoes-documentos"
                data-toggle="tab"
                href="#informacoes-documentos"
                role="tab"
                aria-controls="informacoes-documentos"
                aria-selected="false"
                >DOCUMENTOS</a
              >
              <a
                v-if="permission('read', 'resident_relatives')"
                @click="handleStep('INFORMACOES_FAMILIARES')"
                :class="[
                  'nav-link link-nav-resident',
                  step == 'INFORMACOES_FAMILIARES' && 'active',
                ]"
                id="nav-familiares"
                data-toggle="tab"
                href="#familiares"
                role="tab"
                aria-controls="familiares"
                aria-selected="false"
                >FAMILIARES</a
              >
              <a
                v-if="permission('read', 'agreement')"
                @click="handleStep('INFORMACOES_CONVENIOS')"
                :class="[
                  'nav-link link-nav-resident',
                  step == 'INFORMACOES_CONVENIOS' && 'active',
                ]"
                id="nav-convenios"
                data-toggle="tab"
                href="#convenios"
                role="tab"
                aria-controls="convenios"
                aria-selected="false"
                >CONVÊNIOS</a
              >
              <a
                v-if="permission('read', 'resident_accommodation')"
                @click="handleStep('INFORMACOES_HOSPEDAGEM')"
                :class="[
                  'nav-link link-nav-resident',
                  step == 'INFORMACOES_HOSPEDAGEM' && 'active',
                ]"
                id="nav-informacoes-hospedagem"
                data-toggle="tab"
                href="#informacoes-hospedagem"
                role="tab"
                aria-controls="informacoes-hospedagem"
                aria-selected="false"
                >HOSPEDAGEM</a
              >
              <a
                v-if="permission('read', 'contract_termination')"
                @click="handleStep('ENCERRAMENTO_DE_CONTRATO')"
                :class="[
                  'nav-link link-nav-resident',
                  step == 'ENCERRAMENTO_DE_CONTRATO' && 'active',
                ]"
                id="nav-encerramento-de-contrato"
                data-toggle="tab"
                href="#encerramento-de-contrato"
                role="tab"
                aria-controls="encerramento-de-contrato"
                aria-selected="false"
                >ENCERRAMENTO DE CONTRATO</a
              >
            </div>
          </nav>
          <div class="tab-content">
            <div
              v-if="step == 'INFORMACOES'"
              :class="[
                'tab-pane',
                step == 'INFORMACOES' ? 'show active' : 'fade',
              ]"
              id="informacoes"
              role="tabpanel"
              aria-labelledby="nav-informacoes"
            >
              <form method="post">
                <WarningMessage
                  v-if="!permission('edit', 'resident')"
                  message="Você não tem permissão para modificar residentes"
                />
                <WarningMessage
                  v-if="active == 0"
                  message="Residente inativado por Motivo do encerramento do contrato!"
                />
                <WarningMessage
                  v-if="
                    active == 0 && resident && resident.already_transferred == 1
                  "
                  message="Residente inativado por transferência de filial!"
                />
                <div class="row m-0">
                  <div
                    :class="[
                      'col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12',
                      permission('read', 'resident_photo')
                        ? 'col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12'
                        : 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12',
                    ]"
                  >
                    <div class="row">
                      <div
                        class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8 pb-0"
                      >
                        <v-text-field
                          :disabled="!permission('edit', 'resident')"
                          ref="autofocus"
                          v-model="name"
                          label="Nome "
                          outlined
                          dense
                        />
                      </div>
                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 pb-0"
                      >
                        <v-text-field
                          :disabled="!permission('edit', 'resident')"
                          ref="autofocus"
                          v-model="medical_record_number"
                          label="Número de prontuário "
                          outlined
                          dense
                        />
                      </div>
                      <div
                        class="col-xl-3 col-lg-3 col-md-5 col-sm-4 col-12 pb-0"
                      >
                        <v-select
                          :disabled="!permission('edit', 'resident')"
                          v-model="gender_id"
                          :items="genders"
                          label="Gênero"
                          dense
                          outlined
                          item-value="id"
                          item-text="name"
                        />
                      </div>
                      <div
                        class="d-flex col-xl-6 col-lg-6 col-md-7 col-sm-8 col-12 pb-0"
                      >
                        <v-text-field
                          :disabled="!permission('edit', 'resident')"
                          ref="autofocus"
                          v-model="date_of_birth"
                          label="Data de nascimento "
                          outlined
                          dense
                          type="date"
                        />
                        <p class="mb-0 pt-2 pl-1">
                          {{
                            date_of_birth && date_of_birth.length == 10
                              ? "Idade: " +
                                getAge(formatDateToUs(date_of_birth, true)) +
                                " anos"
                              : ""
                          }}
                        </p>
                      </div>
                      <div
                        class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12 pb-0"
                      >
                        <v-select
                          :disabled="!permission('edit', 'resident')"
                          v-model="status_type_id"
                          :items="statusTypes"
                          label="Status"
                          dense
                          outlined
                          item-value="id"
                          item-text="name"
                        />
                      </div>
                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 pb-0"
                      >
                        <v-select
                          :disabled="!permission('edit', 'resident')"
                          v-model="degree_of_dependence_id"
                          :items="degrees_of_dependence"
                          label="Grau de Dependência"
                          dense
                          outlined
                          item-value="id"
                          item-text="name"
                        />
                        <v-textarea
                          :disabled="!permission('edit', 'resident')"
                          v-model="type_of_food"
                          label="Tipo de alimentação"
                          outlined
                        >
                        </v-textarea>
                      </div>
                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 pb-0"
                      >
                        <v-textarea
                          :disabled="!permission('edit', 'resident')"
                          v-model="pathology"
                          label="Patologia (Doença)"
                          outlined
                        >
                        </v-textarea>
                      </div>
                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 pb-0"
                      >
                        <v-textarea
                          :disabled="!permission('edit', 'resident')"
                          v-model="miscellaneous_allergies"
                          label="Alergia Diversas"
                          outlined
                        >
                        </v-textarea>
                      </div>
                      <div
                        class="col-xl-4 col-lg-4 col-md-5 col-sm-4 col-12 pb-0"
                      >
                        <v-text-field
                          :disabled="!permission('edit', 'resident')"
                          v-model="nickname"
                          label="Apelido"
                          outlined
                          dense
                        />
                      </div>
                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pb-0"
                      >
                        <v-text-field
                          :disabled="!permission('edit', 'resident')"
                          v-model="naturalness"
                          label="Naturalidade"
                          outlined
                          dense
                        />
                      </div>
                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pb-0"
                      >
                        <v-select
                          :disabled="!permission('edit', 'resident')"
                          v-model="marital_status_id"
                          :items="maritalStatus"
                          label="Estado civil"
                          dense
                          outlined
                          item-value="id"
                          item-text="name"
                        />
                      </div>
                      <div
                        class="col-xl-4 col-lg-4 col-md-8 col-sm-8 col-12 pb-0"
                      >
                        <v-text-field
                          :disabled="!permission('edit', 'resident')"
                          v-model="religion"
                          label="Religião"
                          outlined
                          dense
                        />
                      </div>
                      <div
                        class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pb-0"
                      >
                        <v-text-field
                          :disabled="!permission('edit', 'resident')"
                          v-model="profession"
                          label="Profissão"
                          outlined
                          dense
                        />
                      </div>
                      <div
                        class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pb-0"
                      >
                        <v-text-field
                          :disabled="!permission('edit', 'resident')"
                          v-model="schooling"
                          label="Escolaridade"
                          outlined
                          dense
                        />
                      </div>
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
                      >
                        <v-text-field
                          :disabled="!permission('edit', 'resident')"
                          v-model="fathers_name"
                          label="Nome do pai"
                          outlined
                          dense
                        />
                      </div>
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
                      >
                        <v-text-field
                          :disabled="!permission('edit', 'resident')"
                          v-model="mothers_name"
                          label="Nome da mãe"
                          outlined
                          dense
                        />
                      </div>
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
                      >
                        <v-text-field
                          :disabled="!permission('edit', 'resident')"
                          v-model="spouse"
                          label="Cônjuge"
                          outlined
                          dense
                        />
                      </div>
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
                      >
                        <v-textarea
                          :disabled="!permission('edit', 'resident')"
                          v-model="comments"
                          label="Observações"
                          outlined
                        >
                        </v-textarea>
                      </div>
                      <div class="col-md-12 p-0">
                        <ErrorsMessages :errors="errors" />
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <h6 class="mb-0 worksansr">
                          Criação:
                          {{ formatDate(created_at) }}
                        </h6>
                        <h6 class="mb-0 worksansr">
                          Última alteração:
                          {{ formatDate(updated_at) }}
                        </h6>
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-right"
                      >
                        <v-btn
                          v-if="permission('read', 'resident')"
                          type="button"
                          @click="handlePrint"
                          class="btn-print m-1"
                        >
                          <i class="fas fa-print mr-2 text-twenty"></i>
                          IMPRIMIR
                        </v-btn>
                        <v-btn
                          v-if="permission('edit', 'resident')"
                          :disabled="loadingUpdate"
                          type="button"
                          v-on:click="update(false)"
                          class="btn-save m-1"
                        >
                          <i class="fas fa-save mr-2 text-twenty"></i>
                          {{ loadingUpdate ? "Carregando" : "SALVAR" }}
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <b-modal
                    title="IMAGEM"
                    no-close-on-backdrop
                    id="photo"
                    hide-footer
                  >
                    <div class="row">
                      <div
                        v-if="permission('read', 'resident_photo')"
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                      >
                        <b-overlay
                          :show="loadingCreatePhotoResident"
                          opacity="0.99"
                        >
                          <div class="text-center mb-1">
                            <p class="m-0 worksansr text-twelve">
                              A imagem é alterada separadamente das demais
                              informações, caso você tenha informado os campos
                              salve-os primeiro para depois alterar a imagem!
                            </p>
                          </div>
                          <img
                            v-if="photo == null"
                            class="img-fluid rounded mx-auto d-block"
                            :src="require('../../assets/user.png')"
                            width="200"
                            height="auto" />
                          <img
                            v-if="photo"
                            :src="photo"
                            class="img-fluid rounded mx-auto d-block"
                            width="200"
                            height="auto" />
                          <div
                            class="d-flex d-flex justify-content-center"
                          ></div>
                          <div class="text-center mb-2">
                            <span
                              @click="handleGetPhoto"
                              v-if="!photo"
                              class="btn-file btn-upload fileinput-button"
                            >
                              <span
                                class="weight-600 d-flex align-items-center justify-content-center"
                                ><i class="fas fa-camera mr-2 text-twenty"></i>
                                ADICIONAR</span
                              >
                              <input
                                v-if="permission('edit', 'resident_photo')"
                                class="img-file line-break font-file-send mb-3 mt-5"
                                @change="createPhoto($event)"
                                type="file"
                                ref="button_img"
                              />
                            </span>
                          </div>
                          <div class="text-center" v-if="photo !== null">
                            <confirmation-dialog
                              v-if="permission('remove', 'resident_photo')"
                              message-title="CONFIRMAÇÃO"
                              message-body="DESEJA REALMENTE APAGAR A FOTO?"
                              open-left-icon="fa-trash"
                              open-class="btn-delete"
                              open-text="REMOVER"
                              @yes="deletePhoto"
                            /></div
                        ></b-overlay>
                        <p class="mb-0 text-info-img text-center worksansr">
                          Tamanho máximo <strong>10MB</strong>
                        </p>
                        <p class="text-info-img text-center worksansr">
                          Formatos: <strong>JPG, JPEG, PJPEG</strong> e
                          <strong>PNG</strong>
                        </p>
                      </div>
                    </div>
                  </b-modal>
                  <div
                    v-if="permission('read', 'resident_photo')"
                    class="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12"
                  >
                    <b-overlay
                      :show="loadingCreatePhotoResident"
                      opacity="0.99"
                    >
                      <img
                        v-if="photo == null"
                        class="img-fluid rounded mx-auto d-block"
                        :src="require('../../assets/user.png')"
                        width="200"
                        height="auto"
                      />
                      <img
                        v-if="photo"
                        :src="photo"
                        class="img-fluid rounded mx-auto d-block"
                        width="200"
                        height="auto"
                      />
                      <div class="d-flex d-flex justify-content-center"></div>
                      <div class="text-center mb-2">
                        <v-btn
                          class="v-primary mt-1"
                          @click="$bvModal.show('photo')"
                        >
                          {{ photo ? "ALTERAR IMAGEM" : "ADICIONAR IMAGEM" }}
                        </v-btn>
                      </div>
                    </b-overlay>
                    <p class="mb-0 text-info-img text-center worksansr">
                      Tamanho máximo <strong>10MB</strong>
                    </p>
                    <p class="text-info-img text-center worksansr">
                      Formatos: <strong>JPG, JPEG, PJPEG</strong> e
                      <strong>PNG</strong>
                    </p>
                  </div>
                </div>
              </form>
            </div>
            <div
              v-if="step == 'INFORMACOES_ENDERECO'"
              :class="[
                'tab-pane',
                step == 'INFORMACOES_ENDERECO' ? 'show active' : 'fade',
              ]"
              id="informacoes-endereco"
              role="tabpanel"
              aria-labelledby="nav-informacoes-endereco"
            >
              <div class="row m-0 pt-4">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 pb-0">
                  <VTextFieldCEP v-model="cep" @retrieved="evOnCEPRetrieved" />
                </div>
                <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 pb-0">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="address"
                    label="Endereço"
                    outlined
                    hide-details
                    dense
                  />
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 pb-0">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="number_address"
                    label="Nº"
                    outlined
                    hide-details
                    dense
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pb-0">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="neighborhood"
                    label="Bairro"
                    outlined
                    dense
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pb-0">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="city"
                    label="Cidade"
                    outlined
                    hide-details
                    dense
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pb-0">
                  <v-select
                    :disabled="!permission('edit', 'resident')"
                    v-model="uf_id"
                    :items="ufs"
                    label="Estado"
                    dense
                    outlined
                    hide-details
                    item-value="id"
                    item-text="name"
                  />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-4 col-12 pb-0">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="complement"
                    label="Complemento"
                    outlined
                    hide-details
                    dense
                  />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-8 col-12 pb-0">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="reference"
                    label="Referência"
                    outlined
                    hide-details
                    dense
                  />
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <ErrorsMessages :errors="errors" />
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
                >
                  <v-btn
                    v-if="permission('edit', 'resident')"
                    :disabled="loadingUpdate"
                    type="button"
                    v-on:click="update(false)"
                    class="btn-save"
                  >
                    <i class="fas fa-save mr-2 text-twenty"></i>
                    {{ loadingUpdate ? "Carregando" : "SALVAR" }}
                  </v-btn>
                </div>
              </div>
            </div>
            <div
              v-if="step == 'INFORMACOES_DOCUMENTOS'"
              :class="[
                'tab-pane',
                step == 'INFORMACOES_DOCUMENTOS' ? 'show active' : 'fade',
              ]"
              id="informacoes-documentos"
              role="tabpanel"
              aria-labelledby="nav-informacoes-documentos"
            >
              <div class="row m-0 pt-4">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <v-text-field
                    outlined
                    dense
                    label="CPF"
                    :disabled="!permission('edit', 'resident')"
                    v-mask="'###.###.###-##'"
                    v-model="cpf"
                  >
                  </v-text-field>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="rg"
                    label="RG"
                    hide-details
                    outlined
                    dense
                  />
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="issuing_body"
                    label="Orgão expedidor"
                    outlined
                    hide-details
                    dense
                  />
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    type="date"
                    v-model="date_of_issue"
                    label="Data de emissão"
                    outlined
                    hide-details
                    dense
                  />
                </div>
                <div class="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="SUS_card_number"
                    label="Número do cartão SUS"
                    outlined
                    hide-details
                    dense
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="INSS_benefit_number"
                    label="Número do benefício do INSS"
                    outlined
                    hide-details
                    dense
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="type_of_INSS_benefit"
                    label="Tipo de benefício INSS"
                    outlined
                    hide-details
                    dense
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <v-select
                    :disabled="!permission('edit', 'resident')"
                    v-model="inss_benefit_status_id"
                    :items="inss_benefit_status"
                    label="Situação do benefício do INSS"
                    dense
                    outlined
                    hide-details
                    item-value="id"
                    item-text="name"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-on:keyup="handleValueINSSBenefitAmount"
                    v-model="INSS_benefit_amount"
                    label="Valor do benefício do INSS"
                    outlined
                    hide-details
                    dense
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="INSS_update_date"
                    label="Data da atualização do INSS"
                    type="date"
                    outlined
                    hide-details
                    dense
                  />
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0"
                >
                  <ErrorsMessages :errors="errors" />
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-6 col-sm-12 col-12 pt-0 text-right"
                >
                  <v-btn
                    v-if="permission('edit', 'resident')"
                    :disabled="loadingUpdate"
                    type="button"
                    v-on:click="update(false)"
                    class="btn-save mt-5"
                  >
                    <i class="fas fa-save mr-2 text-twenty"></i>
                    {{ loadingUpdate ? "Carregando" : "SALVAR" }}
                  </v-btn>
                </div>
                <div
                  v-if="permission('read', 'resident_documents')"
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                >
                  <hr />
                  <Document
                    :rest_home_id="rest_home_id"
                    :resident_id="resident_id"
                    :user_id="user_id"
                    :users="users"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="step == 'INFORMACOES_FAMILIARES'"
              :class="[
                'tab-pane',
                step == 'INFORMACOES_FAMILIARES' ? 'show active' : 'fade',
              ]"
              id="familiares"
              role="tabpanel"
              aria-labelledby="nav-familiares"
            >
              <CustomerHasResident
                :rest_home_id="rest_home_id"
                :resident_id="resident_id"
                :user_id="user_id"
              />
            </div>
            <div
              v-if="step == 'INFORMACOES_CONVENIOS'"
              :class="[
                'tab-pane',
                step == 'INFORMACOES_CONVENIOS' ? 'show active' : 'fade',
              ]"
              id="convenios"
              role="tabpanel"
              aria-labelledby="nav-convenios"
            >
              <Agreement
                :rest_home_id="rest_home_id"
                :resident_id="resident_id"
                :user_id="user_id"
              />
            </div>
            <div
              v-if="step == 'INFORMACOES_HOSPEDAGEM'"
              :class="[
                'tab-pane',
                step == 'INFORMACOES_HOSPEDAGEM' ? 'show active' : 'fade',
              ]"
              id="informacoes-hospedagem"
              role="tabpanel"
              aria-labelledby="nav-informacoes-hospedagem"
            >
              <div class="row mt-2 m-0 v-clean">
                <div
                  class="col-xl-8 col-lg-8 col-md-8 col-sm-7 col-12 mb-3 mt-3"
                >
                  <h6 class="title-pages mb-0">INFORMAÇÕES DA HOSPEDAGEM</h6>
                </div>
                <div
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-5 col-12 text-right"
                >
                  <!-- <v-btn
                    v-if="permission('write', 'type_of_hosting')"
                    type="button"
                    class="btn-add"
                    @click="$bvModal.show('createTypeOfHosting')"
                  >
                    <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
                  </v-btn> -->
                </div>
                <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-12">
                  <v-select
                    :disabled="!permission('edit', 'resident')"
                    v-model="type_of_hosting_id"
                    :items="typeOfHostings"
                    @change="handleChangeTypeOfStay"
                    label="Tipo de hospedagem"
                    dense
                    outlined
                    hide-details
                    item-value="value"
                    item-text="text"
                  />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    ref="autofocus"
                    v-model="date_of_reception"
                    label="Data da hospedagem"
                    outlined
                    hide-details
                    dense
                    type="date"
                  />
                </div>
                <div
                  class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12 d-flex"
                >
                  <v-select
                    :disabled="!permission('edit', 'resident')"
                    v-model="bed_id"
                    :items="beds"
                    label="Leito do residente"
                    dense
                    outlined
                    hide-details
                    item-value="id"
                    :item-text="
                      (value) => {
                        return value.id
                          ? `Nº ${value.number} - Andar ${value.walk} -
                          Quarto ${value.bedroom} - (ALA/Setor)
                          ${value.ward_or_sector}`
                          : 'NÃO INFORMAR';
                      }
                    "
                  />
                  <div v-if="permission('edit', 'resident')" class="pl-2 mt-1">
                    <v-btn
                      type="button"
                      class="btn-two-add mt-1"
                      @click="$bvModal.show('new_bed')"
                    >
                      <i class="fas fa-plus mr-2 text-twenty"></i>
                      LEITO
                    </v-btn>
                    <br />
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                  <v-select
                    :disabled="!permission('edit', 'resident')"
                    v-model="income_monthly_fee"
                    :items="hosting_type_values"
                    label="Valor da mensalidade"
                    dense
                    outlined
                    hide-details
                    item-value="value"
                    :item-text="
                      (value) => {
                        return `${formatPrice(value.value)} - (Desc) ${
                          value.description
                        }`;
                      }
                    "
                  />
                </div>
                <div class="col-xl-4 col-lg-5 col-md-4 col-sm-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    ref="autofocus"
                    v-model="reason_for_the_reception"
                    label="Motivo da hospedagem"
                    outlined
                    dense
                    hide-details
                  />
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <ErrorsMessages :errors="errors" />
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
                >
                  <v-btn
                    v-if="permission('edit', 'resident')"
                    :disabled="loadingUpdate"
                    type="button"
                    @click="update(false)"
                    class="btn-save"
                  >
                    <i class="fas fa-save mr-2 text-twenty"></i>
                    {{ loadingUpdate ? "Carregando" : "SALVAR" }}
                  </v-btn>
                </div>
              </div>
            </div>
            <div
              v-if="step == 'ENCERRAMENTO_DE_CONTRATO'"
              :class="[
                'tab-pane',
                step == 'ENCERRAMENTO_DE_CONTRATO' ? 'show active' : 'fade',
              ]"
              id="encerramento-de-contrato"
              role="tabpanel"
              aria-labelledby="nav-encerramento-de-contrato"
            >
              <div class="row m-0">
                <div class="col-xl-4 col-lg-3 col-md-4 col-sm-6 col-12 pb-0">
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="date_of_the_withdrawal"
                    label="Data do encerramento do contrato"
                    type="date"
                    outlined
                    dense
                    hide-details
                  />
                </div>
                <div
                  v-if="permission('edit', 'resident')"
                  class="col-xl-8 col-lg-9 col-md-8 col-sm-6 col-12 pb-0"
                >
                  <b-form-group>
                    <v-select
                      label="Motivo do encerramento do contrato"
                      clearable
                      outlined
                      hide-details
                      dense
                      :items="reasons_for_the_withdrawal"
                      v-model="reason_for_the_withdrawal"
                      @click:clear="handleClearReasonForContractTermination"
                    >
                    </v-select>
                  </b-form-group>
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
                  v-if="reason_for_the_withdrawal === 'OUTROS'"
                >
                  <v-text-field
                    :disabled="!permission('edit', 'resident')"
                    v-model="other_reasons"
                    label="Outros motivos"
                    outlined
                    dense
                    hide-details
                  />
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
                >
                  <ErrorsMessages :errors="errors" />
                </div>
                <div
                  class="pt-0 pb-0 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
                >
                  <ConfirmationDialog
                    v-if="permission('edit', 'resident') && active == 1"
                    :disabled="loadingUpdate"
                    headerClass="modal-header-i"
                    message-title="ENCERRAR CONTRATO?"
                    openText="ENCERRAR CONTRATO"
                    message-body="Deseja realmente encerrar o contrato do residente?"
                    open-class="btn-delete"
                    open-left-icon="fa-times"
                    @yes="contractTermination"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../templates/Components/ErrorsMessages";

import WarningMessage from "../../templates/Components/WarningMessage";

import WarningRequiredFields from "../../templates/Components/WarningRequiredFields";

import ConfirmationDialog from "../../templates/Components/ConfirmationDialog";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import permission from "../../lib/permission";

import {
  formatDate,
  formatPrice,
  formatDateToUs,
  formatValueOnKeyUp,
  numbersOnly,
} from "../../lib/format";

import { getAge } from "../../lib/getAgeByDate";

import Agreement from "../../templates/Resident/Agreement";

import CustomerHasResident from "../../templates/Resident/Customer";

import Document from "../../templates/Resident/Document";

import routes from "../../routes";

import { getStatic, userData } from "../../lib/functions";
import NewTypeOfHosting from "../types-of-hosting/new-type-of-hosting.vue";
import NewBed from "../beds/new-bed.vue";

import VTextFieldCEP from "../Components/VTextFieldCEP.vue";

export default {
  name: "Resident",

  components: {
    ErrorsMessages,
    WarningMessage,
    WarningRequiredFields,
    ConfirmationDialog,
    CustomerHasResident,
    Agreement,
    Document,
    NewTypeOfHosting,
    NewBed,
    VTextFieldCEP,
  },

  data() {
    return {
      stepInformation: "BASICO",
      step: "INFORMACOES",
      resident: {},
      user_id: "",
      searchHostingTypeValue: "",
      types_of_stay: [],
      types_of_certificate_document: [
        { text: "Nascimento", value: "NASCIMENTO" },
        { text: "Casamento", value: "CASAMENTO" },
      ],
      reasons_for_the_withdrawal: [
        { text: "Transferência", value: "TRANSFERENCIA" },
        { text: "Óbito", value: "OBITO" },
        { text: "Outros", value: "OUTROS" },
      ],
      users: [],
      put_profilesSelected: [],
      profilesSelected: [],
      profiles: [],
      billing_type_of_hosting_types: [],
      billing_type_of_hosting_type_id: "",
      values: [],
      type_of_hosting_name: "",
      description: "",
      value: "",
      generate: 0,
      statusTypes: [],
      inss_benefit_status: [],
      maritalStatus: [],
      genders: [],
      ufs: [],
      beds: [],
      familysResident: [],
      tmp_resident_id: null,
      typeOfHostings: [],
      customerHasResident: [],
      hosting_type_values: [],
      resident_id: null,
      family_id: "",
      rest_home_id: "",
      status_type_id: "",
      db_status_type_id: "",
      db_status_type_inactive: "",
      marital_status_id: "",
      gender_id: "",
      type_of_hosting_id: "",
      uf_id: "",
      bed_id: "",
      name: "",
      medical_record_number: "",
      date_of_birth: "",
      nickname: "",
      kinship: "",
      rg: "",
      cpf: "",
      issuing_body: "",
      voter_title: "",
      polling_station: "",
      electoral_zone: "",
      type_of_certificate_document: "NASCIMENTO",
      certificate_number: "",
      leaf: "",
      book: "",
      sending_city: "",
      emission_status: "",
      date_of_issue: "",
      SAMS_card_number: "",
      SUS_card_number: "",
      unique_registration_number: "",
      INSS_benefit_number: "",
      type_of_INSS_benefit: "",
      inss_benefit_status_id: "",
      INSS_benefit_amount: "",
      INSS_update_date: "",
      cep: "",
      address: "",
      number_address: "",
      neighborhood: "",
      city: "",
      reference: "",
      complement: "",
      date_of_reception: "",
      income_monthly_fee: "",
      reason_for_the_reception: "",
      IsReasonForTheWithdrawal: null,
      reason_for_the_withdrawal: "",
      date_of_the_withdrawal: "",
      other_reasons: "",
      another_name_institution: "",
      another_time_institution: "",
      another_reason_exchange_institution: "",
      naturalness: "",
      religion: "",
      profession: "",
      schooling: "",
      fathers_name: "",
      mothers_name: "",
      spouse: "",
      preferably_hospitals: "",
      favorite_activities: "",
      comments: "",
      photo: "",
      loadingCreate: false,
      loadingUpdate: false,
      loadingResident: false,
      loadingCreatePhotoResident: false,
      loadingCreateStatus: false,
      bed: "",
      bed_number: "",
      bed_walk: "",
      bed_ward_or_sector: "",
      bed_bedroom: "",
      loadingCreateTypeOfHosting: false,
      loadingCreateHostingTypeValue: false,
      loadingCreateBed: false,
      loadingAnnotation: false,
      loading: true,
      loadingCustomerHasResident: false,
      active: 1,
      created_at: "",
      updated_at: "",
      pathology: "",
      degrees_of_dependence: [],
      degree_of_dependence_id: null,
      degree_of_dependence_name: "",
      miscellaneous_allergies: "",
      type_of_food: "",
      tab: null,
      items: [
        { tab: "One", content: "Tab 1 Content" },
        { tab: "Two", content: "Tab 2 Content" },
        { tab: "Three", content: "Tab 3 Content" },
        { tab: "Four", content: "Tab 4 Content" },
        { tab: "Five", content: "Tab 5 Content" },
        { tab: "Six", content: "Tab 6 Content" },
        { tab: "Seven", content: "Tab 7 Content" },
        { tab: "Eight", content: "Tab 8 Content" },
        { tab: "Nine", content: "Tab 9 Content" },
        { tab: "Ten", content: "Tab 10 Content" },
      ],
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    getAge,
    formatDate,
    formatPrice,
    numbersOnly,
    formatDateToUs,
    formatValueOnKeyUp,

    handleGetPhoto() {
      this.$refs["button_img"].click();
    },

    async getDegreesOfDependence() {
      try {
        this.loading = true;

        const response = await api.get("/default/degrees-of-dependence");
        const { error, errors, degrees_of_dependence } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.degrees_of_dependence = degrees_of_dependence;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    handleInformation() {
      this.getCustomerHasResident();
      this.handleInformationStep("BASICO");
    },

    handleInformationStep(step) {
      let newNav;
      let newAction;

      if (step == "GERAL") {
        newAction = "geral";
      }

      if (step == "BASICO") {
        newAction = "basic";
      }

      let { tab, action } = routes.history.current.query;

      if (action != newAction) {
        routes.replace({ query: { tab, action: newAction, nav: newNav } });
      }

      this.stepInformation = step;
    },

    handleStep(step) {
      let newNav;

      if (step == "INFORMACOES") {
        newNav = "information";
      }

      if (step == "INFORMACOES_ENDERECO") {
        newNav = "address";
      }

      if (step == "INFORMACOES_DOCUMENTOS") {
        newNav = "docs";
      }

      if (step == "INFORMACOES_FAMILIARES") {
        newNav = "customer";
      }

      if (step == "INFORMACOES_CONVENIOS") {
        newNav = "agreement";
      }

      if (step == "INFORMACOES_HOSPEDAGEM") {
        newNav = "hosting";
      }

      if (step == "INFORMACOES_HOSPEDAGEM_FINANCEIRO") {
        newNav = "hosting-finance";
      }

      if (step == "ENCERRAMENTO_DE_CONTRATO") {
        newNav = "contract-termination";
      }

      let { tab, action, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, action, nav: newNav } });
      }

      this.step = step;
    },

    handleClearReasonForContractTermination() {
      // this.reason_for_the_reception = "";
      this.date_of_the_withdrawal = "";
      // this.reason_for_the_withdrawal = "";
      this.other_reasons = "";
    },

    handleValue: function (e) {
      this.value = formatValueOnKeyUp(e.target.value);
    },

    handleValueINSSBenefitAmount: function (e) {
      this.INSS_benefit_amount = formatValueOnKeyUp(e.target.value);
    },

    async evOnCEPRetrieved(value) {
      this.cep = value.cep;
      this.city = value.localidade || this.city;
      this.neighborhood = value.bairro || this.neighborhood;
      // this.complement = value.complemento || this.complement;
      this.address = value.logradouro || this.address;

      const matched_uf = this.ufs.find(
        (item) => item.initials.toLowerCase() === value.uf.toLowerCase()
      );
      if (matched_uf) this.uf_id = matched_uf.id;
    },

    async retrieve() {
      this.rest_home_id = userData().user.rest_home_id;
      this.user_id = userData().user.id;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      const { action, nav } = routes.history.current.query;

      if (action) {
        if (action == "geral") {
          this.stepInformation = "GERAL";
        }

        if (action == "basic") {
          this.stepInformation = "BASICO";
        }
      }

      if (nav) {
        if (nav == "cheers") {
          this.step = "CHEERS";
        }
        if (nav == "information") {
          this.step = "INFORMACOES";
        }

        if (nav == "address") {
          this.step = "INFORMACOES_ENDERECO";
        }

        if (nav == "docs") {
          this.step = "INFORMACOES_DOCUMENTOS";
        }

        if (nav == "customer") {
          this.step = "INFORMACOES_FAMILIARES";
        }

        if (nav == "agreement") {
          this.step = "INFORMACOES_CONVENIOS";
        }

        if (nav == "hosting") {
          this.step = "INFORMACOES_HOSPEDAGEM";
        }

        if (nav == "hosting-finance") {
          this.step = "INFORMACOES_HOSPEDAGEM_FINANCEIRO";
        }

        if (nav == "contract-termination") {
          this.step = "ENCERRAMENTO_DE_CONTRATO";
        }
      }

      this.loading = false;

      if (this.errors.length == 0) await this.get();
      if (this.errors.length == 0) await this.getDegreesOfDependence();
      if (this.errors.length == 0) await this.getCustomerHasResident();
      if (this.errors.length == 0) await this.getStatusResidents();
      if (this.errors.length == 0) await this.getAllBedsWithNoBond();
      if (this.errors.length == 0) await this.getTypeOfHostings();
      if (this.errors.length == 0) await this.handleBeds();
      if (this.errors.length == 0) await this.getUsers();

      if (this.errors.length > 0) return;

      try {
        this.ufs = (await getStatic("/ufs", true)).ufs;
        this.genders = (await getStatic("/genders", true)).genders;
        this.maritalStatus = (
          await getStatic("/rest-home/marital-status/all", true)
        ).marital_status;
        this.billing_type_of_hosting_types = (
          await getStatic("/rest-home/type-of-hosting/types", true)
        ).types;
        this.inss_benefit_status = (
          await getStatic("/rest-home/resident/inss-benefit-status", true)
        ).inss_benefit_status;
      } catch (errors) {
        this.errors = errors;
      }
    },

    async getUsers() {
      try {
        let response = await api.get("/rest-home/users");

        let { error, users } = response.data;

        if (!error) {
          this.users = users;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getStatusResidents() {
      try {
        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          type: "RESIDENTE",
        };

        const response = await api.get("/rest-home/type/status/all", {
          params,
        });

        const { error, errors, status } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          let db_status_type_inactive = status.find(
            (el) => el.value == "INATIVO"
          );

          this.db_status_type_inactive = db_status_type_inactive;
          this.statusTypes = status;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getAllBedsWithNoBond() {
      try {
        const response = await api.get("/rest-home/bed/all");

        const { error, errors, beds } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.beds = [{ id: "" }, ...beds];
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getTypeOfHostings() {
      try {
        const { rest_home_id } = this;

        let params = {
          rest_home_id,
        };

        const response = await api.get("/rest-home/type-of-hosting/all", {
          params,
        });

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          this.types_of_stay = types;

          if (types.length > 0) {
            if (!this.type_of_hosting_id) {
              this.type_of_hosting_id = types[0].value;
              this.handleChangeTypeOfStay(types[0].value);
            } else {
              this.handleChangeTypeOfStay(this.type_of_hosting_id);
            }
          }

          this.typeOfHostings = types;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async handleChangeTypeOfStay(type_of_hosting_id) {
      try {
        let params = {
          type_of_hosting_id,
        };

        const response = await api.get("/rest-home/hosting-type-value/all", {
          params,
        });

        const { error, errors, hosting_type_value } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.hosting_type_values = hosting_type_value;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async update(by_inactive = false) {
      try {
        this.loadingUpdate = true;

        let params = {
          id: this.resident_id,
          rest_home_id: this.rest_home_id,
          status_type_id: this.status_type_id,
          gender_id: this.gender_id,
          type_of_hosting_id: this.type_of_hosting_id,
          marital_status_id: this.marital_status_id,
          uf_id: this.uf_id,
          bed_id: this.bed_id,
          name: this.name,
          medical_record_number: this.medical_record_number,
          date_of_birth: this.date_of_birth,
          nickname: this.nickname,
          naturalness: this.naturalness,
          religion: this.religion,
          profession: this.profession,
          schooling: this.schooling,
          fathers_name: this.fathers_name,
          mothers_name: this.mothers_name,
          spouse: this.spouse,
          preferably_hospitals: this.preferably_hospitals,
          favorite_activities: this.favorite_activities,
          comments: this.comments,
          rg: this.rg,
          cpf: this.cpf,
          issuing_body: this.issuing_body,
          voter_title: this.voter_title,
          polling_station: this.polling_station,
          electoral_zone: this.electoral_zone,
          type_of_certificate_document: this.type_of_certificate_document,
          certificate_number: this.certificate_number,
          leaf: this.leaf,
          book: this.book,
          sending_city: this.sending_city,
          emission_status: this.emission_status,
          date_of_issue: this.date_of_issue,
          SAMS_card_number: this.SAMS_card_number,
          SUS_card_number: this.SUS_card_number,
          unique_registration_number: this.unique_registration_number,
          INSS_benefit_number: this.INSS_benefit_number,
          type_of_INSS_benefit: this.type_of_INSS_benefit,
          inss_benefit_status_id: this.inss_benefit_status_id,
          INSS_benefit_amount: this.INSS_benefit_amount,
          INSS_update_date: this.INSS_update_date,
          cep: this.cep,
          address: this.address,
          number_address: this.number_address,
          neighborhood: this.neighborhood,
          city: this.city,
          reference: this.reference,
          complement: this.complement,
          date_of_reception: this.date_of_reception,
          income_monthly_fee: this.income_monthly_fee,
          reason_for_the_reception: this.reason_for_the_reception,
          reason_for_the_withdrawal: this.reason_for_the_withdrawal,
          date_of_the_withdrawal: this.date_of_the_withdrawal,
          other_reasons: this.other_reasons,
          another_name_institution: this.another_name_institution,
          another_time_institution: this.another_time_institution,
          another_reason_exchange_institution:
            this.another_reason_exchange_institution,
          active: this.active,
          pathology: this.pathology,
          degree_of_dependence_id: this.degree_of_dependence_id,
          miscellaneous_allergies: this.miscellaneous_allergies,
          type_of_food: this.type_of_food,
        };

        let {
          active,
          db_status_type_inactive,
          db_status_type_id,
          status_type_id,
        } = this;

        if (!by_inactive) {
          if (
            active == 1 &&
            db_status_type_inactive &&
            db_status_type_inactive.id &&
            db_status_type_id != db_status_type_inactive.id &&
            status_type_id == db_status_type_inactive.id
          ) {
            this.loadingUpdate = false;
            this.$bvModal.show("confirm-inactive-user");
          } else {
            this.handleUpdate(params);
          }
        } else {
          this.handleUpdate(params);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async contractTermination() {
      try {
        this.loadingUpdate = true;

        let params = {
          id: this.resident_id,
          reason_for_the_withdrawal: this.reason_for_the_withdrawal,
          date_of_the_withdrawal: this.date_of_the_withdrawal,
          other_reasons: this.other_reasons,
        };

        const response = await api.patch(
          "/rest-home/resident/contract-termination",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.errors = [];
          this.get();
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleUpdate(params) {
      try {
        const response = await api.patch("/rest-home/resident/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.errors = [];
          this.get();
        } else {
          this.errors = errors;
        }
        this.$bvModal.hide("confirm-inactive-user");
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    orderByNumber(a, b) {
      return a.number - b.number;
    },

    async handleBeds() {
      try {
        const { rest_home_id, resident_id } = this;

        const response = await api.get("/rest-home/bed", {
          params: { rest_home_id, resident_id },
        });

        const { error, errors, beds } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.beds = [{ id: "" }, ...beds.sort(this.orderByNumber)];
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getCustomerHasResident() {
      try {
        this.loadingCustomerHasResident = true;

        const { resident_id } = this;

        const response = await api.get("/rest-home/customer/by-resident", {
          params: { resident_id },
        });

        const { error, errors, customerHasResident } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.customerHasResident = customerHasResident;
        }

        this.loadingCustomerHasResident = false;
      } catch (error) {
        console.log(error);
      }
    },

    async get() {
      try {
        this.loading = true;

        const { resident_id, rest_home_id } = this;

        const response = await api.get("/rest-home/resident", {
          params: { id: resident_id, rest_home_id },
        });

        const { resident, bed, error } = response.data;

        if (error) {
          return routes.push({ name: "residents" });
        }

        this.bed = bed;

        this.resident = resident;
        this.status_type_id = resident.status_type_id;
        this.db_status_type_id = resident.status_type_id;
        this.gender_id = resident.gender_id;
        this.type_of_hosting_id = resident.type_of_hosting_id;
        this.marital_status_id = resident.marital_status_id;
        this.uf_id = resident.uf_id;
        this.bed_id = resident.bed_id;
        this.name = resident.name;
        this.medical_record_number = resident.medical_record_number;
        this.date_of_birth = formatDateToUs(resident.date_of_birth);
        this.nickname = resident.nickname;
        this.naturalness = resident.naturalness;
        this.religion = resident.religion;
        this.profession = resident.profession;
        this.schooling = resident.schooling;
        this.fathers_name = resident.fathers_name;
        this.mothers_name = resident.mothers_name;
        this.spouse = resident.spouse;
        this.preferably_hospitals = resident.preferably_hospitals;
        this.favorite_activities = resident.favorite_activities;
        this.comments = resident.comments;
        this.rg = resident.rg;
        this.cpf = resident.cpf;
        this.issuing_body = resident.issuing_body;
        this.voter_title = resident.voter_title;
        this.polling_station = resident.polling_station;
        this.electoral_zone = resident.electoral_zone;
        this.type_of_certificate_document =
          resident.type_of_certificate_document;
        this.certificate_number = resident.certificate_number;
        this.leaf = resident.leaf;
        this.book = resident.book;
        this.sending_city = resident.sending_city;
        this.emission_status = resident.emission_status;
        this.date_of_issue = formatDateToUs(resident.date_of_issue);
        this.SAMS_card_number = resident.SAMS_card_number;
        this.SUS_card_number = resident.SUS_card_number;
        this.unique_registration_number = resident.unique_registration_number;
        this.INSS_benefit_number = resident.INSS_benefit_number;
        this.type_of_INSS_benefit = resident.type_of_INSS_benefit;
        this.inss_benefit_status_id = resident.inss_benefit_status_id;
        this.INSS_benefit_amount = formatPrice(resident.INSS_benefit_amount);
        this.INSS_update_date = formatDateToUs(resident.INSS_update_date);
        this.cep = resident.cep;
        this.address = resident.address;
        this.number_address = resident.number_address;
        this.city = resident.city;
        this.neighborhood = resident.neighborhood;
        this.city = resident.city;
        this.reference = resident.reference;
        this.complement = resident.complement;
        this.date_of_reception = formatDateToUs(resident.date_of_reception);
        if (resident.type_of_hosting_id) {
          this.handleChangeTypeOfStay(resident.type_of_hosting_id);
        }
        if (resident.income_monthly_fee) {
          this.income_monthly_fee = resident.income_monthly_fee;
        } else {
          this.income_monthly_fee = 0;
        }
        this.reason_for_the_reception = resident.reason_for_the_reception;
        this.IsReasonForTheWithdrawal = resident.reason_for_the_withdrawal;
        this.reason_for_the_withdrawal = resident.reason_for_the_withdrawal;
        this.date_of_the_withdrawal = formatDateToUs(
          resident.date_of_the_withdrawal
        );
        this.other_reasons = resident.other_reasons;
        this.another_name_institution = resident.another_name_institution;
        this.another_time_institution = resident.another_time_institution;
        this.another_reason_exchange_institution =
          resident.another_reason_exchange_institution;
        this.photo = resident.photo_url;
        this.active = resident.active;
        this.created_at = resident.created_at;
        this.updated_at = resident.updated_at;

        this.pathology = resident.pathology;
        this.degree_of_dependence_id = resident.degree_of_dependence_id;
        this.degree_of_dependence_name = resident.degree_of_dependence_name;
        this.miscellaneous_allergies = resident.miscellaneous_allergies;
        this.type_of_food = resident.type_of_food;

        this.$emit("get", resident);

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async createPhoto(event) {
      try {
        event.preventDefault();

        this.loadingCreatePhotoResident = true;

        const { user_id, resident_id } = this;

        const formData = new FormData();

        let photo = event.target.files[0];

        if (!photo) {
          this.loadingCreatePhotoResident = false;
          return toast("Informe a foto", "error");
        }

        const allowedMimes = [
          "image/jpg",
          "image/jpeg",
          "image/pjpeg",
          "image/png",
        ];

        if (!allowedMimes.includes(photo.type)) {
          this.loadingCreatePhotoResident = false;
          return toast("Formato de arquivo inválido", "error");
        }

        var limitSize = 10 * 1024 * 1024;

        if (photo.size > limitSize) {
          this.loadingCreatePhotoResident = false;
          return toast("Suportado até 10MB", "error");
        }

        formData.append("user_id", user_id);
        formData.append("id", resident_id);
        formData.append("photo", photo, photo.name);

        const response = await api.post("/rest-home/resident/photo", formData);

        const { error, message, errors } = response.data;

        if (!error) {
          toast(message, "success");
          this.get();
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingCreatePhotoResident = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deletePhoto() {
      try {
        this.loadingCreatePhotoResident = true;

        const { user_id, resident_id } = this;

        let data = {
          user_id,
          id: resident_id,
        };
        const response = await api.delete("/rest-home/resident/photo", {
          data,
        });

        const { error, message, errors } = response.data;

        if (!error) {
          toast(message, "success");
          this.get();
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingCreatePhotoResident = false;
      } catch (error) {
        console.log(error);
      }
    },

    handlePrint() {
      const { resident_id: id } = this;

      let route = this.$router.resolve({
        name: "print_resident",
        params: {
          id,
        },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>

<style>
.text-info-img {
  font-size: 12px;
}

.border-type {
  border: 1px solid #f1f1f1;
}
</style>
